import React from "react";
import "../styles/ConfirmModal.css";

const ConfirmModal = ({ open, title, message, onConfirm, onCancel, confirmLabel = "Confirmar", cancelLabel = "Cancelar", loading = false }) => {
  if (!open) return null;
  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="confirm-modal-title">{title}</h3>
        <p className="confirm-modal-message">{message}</p>
        <div className="confirm-modal-actions">
          <button className="confirm-btn-cancel" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button className="confirm-btn-confirm" onClick={onConfirm} disabled={loading}>
            {loading ? "⏳" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
